import {
  verify_additional_application_document,
  verify_application_document
} from '@/services/onboarding_journey_application_service';
import {
  normalize_text,
  read_safe_object_value,
  write_safe_object_value
} from '@/services/onboarding_form_helpers';
import {
  getSelectedForm,
  history_document_status_label
} from './queue_form_method_shared';

export const queueFormDocumentReviewMethods = {
  history_document_review_comment(document = {}) {
    return read_safe_object_value(this.history_document_review_comments, document?.id, '');
  },
  set_history_document_review_comment(document = {}, value = '') {
    if (!document?.id) return;
    write_safe_object_value(this.history_document_review_comments, document.id, String(value || ''));
  },
  is_history_document_review_busy(document = {}) {
    return Boolean(read_safe_object_value(this.history_document_review_in_progress_by_id, document?.id, false));
  },
  is_history_document_review_approved(document = {}) {
    const verification_state = normalize_text(document?.verification_state);
    return document?.is_verified === true || verification_state === 'verified';
  },
  history_document_review_status_label(document = {}) {
    return history_document_status_label(document);
  },
  async run_history_document_review(document = {}, is_verified = true) {
    if (!this.is_history_document_review_supported(document)) {
      this.history_document_review_feedback = this.unsupported_history_document_review_reason(document);
      this.history_document_review_feedback_tone = 'warning';
      return;
    }

    const application_id = Number(this.$route.params.applicationId || this.hydrated_case_detail?.application_id || 0);
    if (!application_id) {
      this.history_document_review_feedback = 'Unable to determine which application this document belongs to.';
      this.history_document_review_feedback_tone = 'danger';
      return;
    }

    const verification_comment = this.history_document_review_comment(document);
    write_safe_object_value(this.history_document_review_in_progress_by_id, document.id, true);
    this.history_document_review_feedback = '';

    try {
      if (normalize_text(document?.source) === 'additional') {
        await verify_additional_application_document({
          application_id,
          additional_document_id: document.id,
          is_verified,
          verification_comment
        });
      } else {
        await verify_application_document({
          application_id,
          application_form_id: document.application_form_id,
          section_id: document.section_id,
          question_id: document.question_id,
          is_verified,
          verification_comment
        });
      }

      this.history_document_review_feedback = is_verified
        ? 'Document approved successfully.'
        : 'Document rejected successfully.';
      this.history_document_review_feedback_tone = is_verified ? 'success' : 'warning';
      await this.refresh_history_documents();
    } catch (error) {
      this.history_document_review_feedback = error?.response?.data?.message || error?.message || 'Unable to update the document review decision.';
      this.history_document_review_feedback_tone = 'danger';
    } finally {
      write_safe_object_value(this.history_document_review_in_progress_by_id, document.id, false);
    }
  },
  async refresh_history_documents() {
    const selected_form = getSelectedForm(this.application_forms, this.selected_application_form_id);
    await this.load_workflow_stage_timeline(selected_form);
  }
};
